<script type="text/jsx">
import { get, getLabelByValue } from '@lsfe/tools';

export default {
    props: {
        remoteConfig: {
            type: Object,
            required: true,
        },
        value: {
            required: true,
        },
    },
    data() {
        return {
            list: [],
        };
    },
    watch: {
        remoteConfig(val) {
            this.fetchRemoteData(val);
        },
    },
    created() {
        this.fetchRemoteData(this.remoteConfig);
    },
    methods: {
        fetchRemoteData(config = {}) {
            const {
                type = 'hPost', url = '', params = {}, options = {}, responseProcessor, valueKey = 'value', labelKey = 'label',
            } = config;
            this[`$${type}`](url, params, options).then((data) => {
                if (responseProcessor) {
                    this.list = responseProcessor(data);
                } else {
                    this.list = (data || []).map((item) => ({ label: get(item, labelKey), value: get(item, valueKey) }));
                }
            });
        },
    },
    render() {
        return (
            <div>{getLabelByValue(this.value, this.list)}</div>
        );
    },
};
</script>
